import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';
import CheckBox from '../../components/common/inputs/checkBox';
import toastr from 'toastr';

/* Actions */
import * as metricAdminActions from '../../actions/metricAdmin/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import FormPopup from '../../components/metricAdmin/formPopup';
import VersionDetailPopup from '../../components/metricAdmin/versionDetailPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import EntityUseQuery from '../entityUseQuery';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  metricVersionPopup: "metricVersionPopup",
  entityUseQuery: "entityUseQuery",
  formPopup: "formPopup",
  closeFormConfirmPopup: "closeFormConfirmPopup",
}

class MetricAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false,
        showExcludedMetrics: false,
        selectedTags: [],
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.metricList,
      entityApiKey: "metric",      
      initialNewEntity: { dimensions: [], unique: true, virtual_marks_labels: [], exclude_from_auto_groups: false,
        exclude_from_system_dimension_metrics: false, dynamic_metric_force_calculation_cache: false,
        metric_type: Constants.metricAdmin.metricType.STANDARD, allow_unknown_calculation_unit_dimension: false, tags: []},
      entityUseQueryId: "",
      formHasChanges: false,
    };
  }
 
  componentDidMount() {
    EntityTableTooling.fetchList(this);
    this.props.actions.getDimensionsList();
    this.props.actions.getTagsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    EntityTableTooling.feedbackMessages(this, prevProps, 
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "metricAdmin.entityNameSingularWithArticle"})),
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "metricAdmin.entityNamePlural"})),
      intl.formatMessage({id: "metricAdmin.genderVocal"}),
      (this.props.delete.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.delete.errors.message : ""),
      (this.props.save.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.save.errors.message : ""),
      true,
    );
  }

  getListQueryParams(defaultQueryParams) {
    let newQueryParams = defaultQueryParams;
    let fieldsAre = [];
    let searchesAre = [];
    if(!this.state.topControlsFormData.showExcludedMetrics) {
      fieldsAre.push("exclude_from_auto_groups");
      searchesAre.push("false");
    }
    if(!this.state.topControlsFormData.showDisabledEntities) {
      fieldsAre.push("active");
      searchesAre.push(true);
    }

    let tags_filter = [];
    if(this.state.topControlsFormData.selectedTags.length > 0) {
      tags_filter = this.state.topControlsFormData.selectedTags;
    }
    newQueryParams.tags_filter = tags_filter;
    
    newQueryParams.fields_are = fieldsAre;
    newQueryParams.searches_are = searchesAre;
    return newQueryParams;
  }

  handleOnChangeForm = (event) => {    
    if(event.currentTarget.dataset.selectlist) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let dimensions = JavascriptUtilsTooling.deepCopy(
        JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
      );
            
      if(isDelete) { 
        delete dimensions[index];
        dimensions = dimensions.filter(item => item);
      } else {
        dimensions.push({id: listValue, name: (this.props.dimensionsList.data.find(item => item.id==listValue)).name });
      }
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path,dimensions);      
      this.setState({ formHasChanges: true });
    }
    else if(event.currentTarget.dataset.objecteditor) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = JSON.parse(event.currentTarget.dataset.value);
      let isDelete = event.currentTarget.dataset.delete;
      let isEdit = event.currentTarget.dataset.edit;
      let objectDefinition = [];
      
      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }
      
      if(isDelete) { 
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      } else if(isEdit) {
        objectDefinition[index] = objectValue;
      }  else {
        objectDefinition.push(objectValue);
      }
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path,objectDefinition);
      this.setState({ formHasChanges: true });
    }
    else if(event.currentTarget.dataset.tagslist){
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = event.currentTarget.dataset.value
      let isDelete = event.currentTarget.dataset.delete;
      let objectDefinition = [];
      
      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }
      
      if(isDelete) { 
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      } else {
        if(objectDefinition.includes(objectValue)) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.error(intl.formatMessage({id: "common.errors.duplicatedTag"}));
        }
        else if(objectDefinition.map(item => item.toLowerCase()).includes(objectValue.toLowerCase())) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.error(intl.formatMessage({id: "common.errors.duplicatedNonCapitalizedTag"}));
        }         
        else{
          objectDefinition.push(objectValue);
        }
      }
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path,objectDefinition);
      this.setState({ formHasChanges: true });
    }
    else {
      EntityTableTooling.handleOnChangeForm(this, event);
    }    
  };

  handleShowMetricVersionPopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.metricVersionPopup, this.state, 
      this.setState.bind(this), false, () => {
        let versionObject = JSON.parse(event.currentTarget.dataset.entitydata);        
        this.props.actions.setMetricVersion(versionObject);   
      }
    );
  };

  handleEntityQueryDataPopup = event => { 
    InterfaceTooling.handleShowPopup(
      event, popupIds.entityUseQuery, this.state, 
      this.setState.bind(this), this.props.loadingEntityUseQueryData, () => {
        this.setState({
          entityUseQueryId: JSON.parse(event.currentTarget.dataset.entityid)
        });
      }
    );
  };
  
  handleShowFormPopupToClone = (event) => {
    InterfaceTooling.handleShowFormPopupWithConfirmOnExit(
      event, popupIds.formPopup, this.state, 
      this.setState.bind(this), (this.props.save.loading), () => {
        let entityObject = {};
        let parsedObject = JSON.parse(event.currentTarget.dataset.entitydata);
        entityObject[this.state.entityApiKey] = parsedObject
        entityObject["clone"] = true;
        delete entityObject[this.state.entityApiKey]["id"];
        this.props.actions.resetSaveEntity(entityObject);
        this.setState({
          formHasChanges: false
        });
      }
    );
  }

  render() {
    var loadingView = this.props.list.firstLoading || this.props.dimensionsList.firstLoading || this.props.tagsList.firstLoading;
    var errorLoadingView = (this.props.list.status !== null && this.props.list.status !== 200) ||
        (this.props.dimensionsList.status !== null && this.props.dimensionsList.status !== 200) ||
        (this.props.tagsList.status !== null && this.props.tagsList.status !== 200);

    let tagsArray = (this.props.tagsList && this.props.tagsList.status == 200) ? this.props.tagsList.data : [];
    return (
      <section className="dashboard_content_inner_view entity_admin_container metric_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleDelete={EntityTableTooling.handleDeletePopup.bind(null, this)}
                handleActive={EntityTableTooling.handleActivePopup.bind(null, this)}
                handleCustomActions={[this.handleShowFormPopupToClone]}
                customActionsIcons={["clone"]}
                customActionsTooltips={[
                  intl.formatMessage({ id: "common.entityTableActions.clone"})
                ]}
                enableTagsSearch={true}
                tagsOptions={tagsArray}
                extraControls={
                  <div>
                    <CheckBox 
                      className="top_controls_show_disabled_entities"
                      id="showExcludedMetrics"
                      value={this.state.topControlsFormData.showExcludedMetrics}
                      onChange={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                      labelLocale={<FormattedMessage id="metricAdmin.showExcludedMetrics"/>}
                    />
                  </div>
                }
              />
              <FormPopup
                handleShowPopup={EntityTableTooling.handleShowFormPopupWithConfirmOnExit.bind(null, this)}
                handleOnChangeForm={this.handleOnChangeForm}
                handleButton={EntityTableTooling.handleOnSaveForm.bind(null, this)}
                loadingButton={this.props.save.loading}
                fullLoading={this.props.save.loading}
                statusButton={this.props.save.status}
                formData={this.props.save.data}
                dimensionsList={this.props.dimensionsList.data}
                errors={this.props.save.errors}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleShowMetricVersionPopup={this.handleShowMetricVersionPopup}
                handleEntityQueryDataPopup={this.handleEntityQueryDataPopup}
                popupState={EntityTableTooling.getFormPopupState(this)}
                tagsOptions={tagsArray}
              />
              <VersionDetailPopup
                handleShowPopup={this.handleShowMetricVersionPopup}
                versionData={this.props.metricVersion}
                popupState={this.state[popupIds.metricVersionPopup]}
              />
              <EntityUseQuery
                popupState={this.state[popupIds.entityUseQuery]}
                entityDefaultType={Constants.selectKeys.entityUseQuery.entityTypes.METRIC}
                entityDefaultId={this.state.entityUseQueryId}
                handleEntityQueryDataPopup={this.handleEntityQueryDataPopup}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirmTitle"}
                 values={{entityNameSingular: (<FormattedMessage id={"metricAdmin.entityNameSingular"}/>)}}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirm"}
                 values={{entityNameSingular: (<FormattedMessage id={"metricAdmin.entityNameSingularWithArticle"}/>)}}
                />)}
                handleConfirm={EntityTableTooling.handleDeleteConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleDeletePopup.bind(null, this)}
                popupState={EntityTableTooling.getDeletePopupState(this)}
                loading={this.props.delete.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirmTitle"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"metricAdmin.entityNameSingular"}/>),
                    activeAction: this.props.save.data.metric && this.props.save.data.metric.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirm"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"metricAdmin.entityNameSingularWithArticle"}/>),
                    activeAction: this.props.save.data.metric && this.props.save.data.metric.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                handleConfirm={EntityTableTooling.handleActiveConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleActivePopup.bind(null, this)}
                popupState={EntityTableTooling.getActivePopupState(this)}
                loading={this.props.save.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"common.confirmExitPopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"common.confirmExitPopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseForm.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
                loading={false}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.metricAdmin.list,
  dimensionsList: state.reducer.metricAdmin.dimensionsList,
  save: state.reducer.metricAdmin.save,
  delete: state.reducer.metricAdmin.delete,
  metricVersion: state.reducer.metricAdmin.metricVersion,
  loadingEntityUseQueryData: state.reducer.entityUseQuery.queryData.loading,
  tagsList: state.reducer.metricAdmin.tagsList,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(metricAdminActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

MetricAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MetricAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/metricAdmin/index.jsx